import { type AxiosResponse } from 'axios';

import { axiosErrors, customRes, type ApiResponse, type CustomAxiosResponse } from './AxiosResponse';
import { RES_SUCCESS, RES_SUCCESS_201 } from '@/lib/common/name-space';
import { camelToSnakeCase } from '@/lib/convert-code-style';

export interface EndpointPayload {
  path: string;
  body?: any;
}

export const sendRequest = async (
  payload: EndpointPayload,
  functionName: string,
  axiosApi: any,
  row: boolean = false, // object를 snakeToCamelCase로 데이터 한 개씩 쪼개기 때문에 추가
  isErrorAlert: boolean = true, // ture: 알럿 나옴, false: 안나옴 (결과 알럿이 안나오게 설정)
): Promise<CustomAxiosResponse> => {
  try {
    const body = camelToSnakeCase(payload?.body) || null;
    const response: AxiosResponse<ApiResponse> = await axiosApi({ path: payload.path, body });
    if (response.data?.statusCode !== RES_SUCCESS && response.data?.statusCode !== RES_SUCCESS_201) {
      return await axiosErrors(null, functionName, isErrorAlert);
    }
    const re: CustomAxiosResponse = customRes(response, row);
    return re;
  } catch (e) {
    return await axiosErrors(e, functionName, isErrorAlert);
  }
};
